import { useEffect } from 'react';

import { useSelector, useStore } from 'react-redux';

import Global from '../../store/global-selectors';
import { createRateComparisonMetadata } from './create-rate-comparison-metadata';

export const useAlternativeRatesShippingServiceRecommendation = ({
  fulfillmentPlanId,
  compareRates,
  setShouldShowComparison,
  alternativeRatesRecommendation,
}) => {
  const recommendedService = useSelector((state) =>
    Global.selectSellerServiceById(state, {
      serviceId: alternativeRatesRecommendation?.service?.serviceId,
    }),
  );

  const { getState } = useStore();

  useEffect(() => {
    if (!alternativeRatesRecommendation?.service || !recommendedService) {
      setShouldShowComparison(false);
      return;
    }

    compareRates({
      userRatesTotalCost: alternativeRatesRecommendation?.userRatesTotalCost,
      comparedRatesTotalCost: alternativeRatesRecommendation?.service?.totalCost,
      comparedService: recommendedService,
      metadata: createRateComparisonMetadata(getState(), fulfillmentPlanId),
    });
  }, [
    alternativeRatesRecommendation?.service,
    alternativeRatesRecommendation?.userRatesTotalCost,
    compareRates,
    fulfillmentPlanId,
    getState,
    recommendedService,
    setShouldShowComparison,
  ]);
};
